import { About } from "../sections/About";

export default function AboutPage() {
  return (
    <main className="pt-10" data-testid="about-page">
      <About />
    </main>
  );
}
